{
    "formControls": {
        "formRows": [
            {
                "formGroups": [
                {
                    "style": {
                        "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "containerNo",
                        "displayLabel": "Container No",
                        "disabled": true,
                        "placeHolder": "Enter Container No",
                        "fieldInfo": {
                            "dataType": "text"
                        }
                    }
                },
                {
                    "style": {
                        "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "shippingLineId",
                        "displayLabel": "Shipping Line",
                        "disabled": false,
                        "placeHolder": "Select Shipping Line",
                        "fieldInfo": {
                            "dataType": "picklist",
                            "lookupDetails": {
                                "apiUrl": "v1/customers/list",
                                "filterByKeys": ["NAME_CONTAINS"],
                                "limit": 10,
                                "orderBy": { "name": "asc" },
                                "bindLabel": "name",
                                "bindValue": "id",
                                "additionalFilters": [
                                    {
                                        "name": "IS_ACTIVE",
                                        "alias": "active",
                                        "operator": "EQ",
                                        "value": ["true"]
                                    },
                                    {
                                        "name": "CUSTOMER_TYPE_CONTAINS",
                                        "alias": "customerType",
                                        "operator": "IN",
                                        "value": ["LINE"]
                                    }
                                ],
                                "displayColumns": [
                                    { "key": "code", "header": "Code" },
                                    { "key": "name", "header": "Name" }
                                ]
                            }
                        },
                        "validators": [
                            {
                                "type": "autocompleteRequired",
                                "message": "Shipping Line is required"
                            }
                        ]
                    }
                }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "isoCode",
                            "displayLabel": "ISO Code",
                            "placeHolder": "Enter Container Size",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/size-type/alias/list",
                                    "selectFields": ["id", "alias", "sizeTypeId.size AS size", "sizeTypeId.type AS type"],
                                    "filterByKeys": ["alias"],
                                    "limit": 10,
                                    "orderBy": { "alias": "asc" },
                                    "bindLabel": "alias",
                                    "bindValue": "alias",
                                    "displayColumns": [
                                        { "key": "alias", "header": "Alias" },
                                        { "key": "size", "header": "Size" },
                                        { "key": "type", "header": "Type" }
                                    ]
                                }
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "containerSize",
                            "displayLabel": "Size",
                            "placeHolder": "Enter Container Size",
                            "isReadOnly": true,
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "containerType",
                            "displayLabel": "Type",
                            "placeHolder": "Enter Container Type",
                            "isReadOnly": true,
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups": [
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "vesselId",
                            "displayLabel": "Vessel",
                            "disabled": false,
                            "placeHolder": "Select Vessel",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/vessel-port-train-details/list?useNewContract=true",
                                    "filterByKeys": ["VESSEL_NAME_CONTAINS", "VIA_NO_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "vesselName",
                                    "bindValue": "id",
                                    "additionalFilters": [{
                                        "name": "IS_ACTIVE",
                                        "alias": "IS_ACTIVE",
                                        "value": ["true"]
                                    }],
                                    "displayColumns": [
                                        { "key": "vesselName", "header": "Vessel Name" },
                                        { "key": "viaNo", "header": "Via No" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Vessel is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "accountHolderId",
                            "displayLabel": "Primary Customer",
                            "disabled": false,
                            "placeHolder": "Select Primary Customer",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/customers/list",
                                    "filterByKeys": ["NAME_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "name",
                                    "bindValue": "id",
                                    "additionalFilters": [{
                                        "name": "IS_ACTIVE",
                                        "alias": "active",
                                        "operator": "EQ",
                                        "value": ["true"]
                                    }],
                                    "displayColumns": [
                                        { "key": "code", "header": "Code" },
                                        { "key": "name", "header": "Name" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Primary Customer is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "secondaryCustomerId",
                            "displayLabel": "Secondary Customer",
                            "disabled": false,
                            "placeHolder": "Select Secondary Customer",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/customers/list",
                                    "filterByKeys": ["NAME_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "name",
                                    "bindValue": "id",
                                    "additionalFilters": [{
                                        "name": "IS_ACTIVE",
                                        "alias": "active",
                                        "operator": "EQ",
                                        "value": ["true"]
                                    }],
                                    "displayColumns": [
                                        { "key": "code", "header": "Code" },
                                        { "key": "name", "header": "Name" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Primary Customer is required"
                                }
                            ]
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "tareWeight",
                            "displayLabel": "Tare Weight",
                            "placeHolder": "Enter Tare Weight",
                            "fieldInfo": {
                                "dataType": "number"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "totalPackages",
                            "displayLabel": "NOP",
                            "placeHolder": "Enter NOP",
                            "fieldInfo": {
                                "dataType": "number"
                            }
                        }
                    },{
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "cargoWeight",
                            "displayLabel": "Cargo Weight",
                            "placeHolder": "Enter Cargo Weight",
                            "fieldInfo": {
                                "dataType": "number"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "reeferPluggedIn",
                            "skipLabel": true,
                            "displayLabel": "Reefr Plugged In",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "odc",
                            "skipLabel": true,
                            "displayLabel": "ODC",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "dpd",
                            "skipLabel": true,
                            "displayLabel": "DPD",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "hazardous",
                            "skipLabel": true,
                            "displayLabel": "Hazardous",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "imdgClass",
                            "displayLabel": "IMDG Class",
                            "placeHolder": "Enter IMDG Class",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "conditions": {
                                "disabled": {
                                    "logic": "AND",
                                    "rules": [
                                    { "field": "hazardous", "operator": "EQUALS", "value": false }
                                    ]
                                }
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "unNo",
                            "displayLabel": "UN No",
                            "placeHolder": "Enter UN No",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "conditions": {
                                "disabled": {
                                    "logic": "AND",
                                    "rules": [
                                    { "field": "hazardous", "operator": "EQUALS", "value": false }
                                    ]
                                }
                            }
                        }
                    }
                ]
            },
            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "lineSealNo",
                            "displayLabel": "Line Seal No",
                            "placeHolder": "Enter Seal No",
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "scanType",
                            "displayLabel": "Scan Type",
                            "placeHolder": "Enter Scan Type",
                            "fieldInfo": {
                                "dataType": "select",
                                "options": []
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "importType",
                            "displayLabel": "Import Type",
                            "placeHolder": "Select Import Type",
                            "fieldInfo": {
                                "dataType": "select",
                                "options": []
                            }
                        }
                    }
                ]
            }
        ]
    }
}
